module.exports = __webpack_public_path__ + "static/media/foto5.f6016a6d.jpg";